/* src/app/components/payroll/invoices/invoice-adjust-void-entry/invoice-adjust-void-entry.component.css */
::ng-deep ppl-dialog div.popup-dialog.position-dialog div.content.medium {
  width: 90vw;
  max-width: 90%;
}
::ng-deep ppl-dialog div.popup-dialog.position-dialog.limit-dialog-width div.content.medium {
  max-width: 65%;
}
.table-scroll-wrapper {
  width: 100%;
  overflow-x: auto;
  overflow-y: visible;
  -webkit-overflow-scrolling: touch;
}
.invoice-adjust-table {
  table-layout: fixed;
  width: 100%;
  font-size: 12px;
  border-collapse: separate;
  border-spacing: 0;
}
.invoice-adjust-table.wide-layout {
  min-width: 1200px;
}
.invoice-adjust-table th,
.invoice-adjust-table td {
  border: none;
  padding: 8px 10px !important;
  vertical-align: top;
  word-break: break-word;
  overflow-wrap: anywhere;
}
.invoice-adjust-table tr {
  vertical-align: top !important;
}
.invoice-adjust-table th {
  font-weight: 600;
  line-height: 1.3;
}
.invoice-adjust-table .ant-select,
.invoice-adjust-table input.ant-input,
.invoice-adjust-table nz-date-picker {
  font-size: 12px !important;
  width: 100% !important;
}
.invoice-adjust-table .ant-select-selector,
.invoice-adjust-table .ant-picker,
.invoice-adjust-table input.ant-input {
  height: 32px !important;
  min-height: 32px !important;
  box-sizing: border-box !important;
  padding: 0 11px !important;
  border-radius: 4px;
}
.invoice-adjust-table .ant-select-single .ant-select-selector .ant-select-selection-item,
.invoice-adjust-table .ant-select-single .ant-select-selector .ant-select-selection-placeholder {
  line-height: 30px;
}
.invoice-adjust-table nz-date-picker .ant-picker-input,
.invoice-adjust-table nz-date-picker .ant-picker-input > input {
  width: 100%;
  height: 100%;
  font-size: 12px !important;
  line-height: 30px !important;
  color: rgba(0, 0, 0, 0.88);
  padding: 0;
  border: none;
  background: transparent;
}
.invoice-adjust-table tr .previous-value {
  display: inline-block;
  width: 100%;
  word-break: break-word;
  line-height: 1.4;
  color: #333;
}
.required-marker {
  color: red;
}
.error-message {
  color: red;
  font-size: 11px;
  min-height: 14px;
  line-height: 1.3;
}
.save-row {
  margin-top: 16px;
  padding: 0 4px;
}
/*# sourceMappingURL=invoice-adjust-void-entry.component-TRXGTSEN.css.map */
